import React from 'react'
import { Redirect, Route } from 'react-router-dom'

const ProtectedMigrateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        props.location?.state?.fromApp === true
          ? <Component {...props} />
          : <Redirect to="/welcome" />
      }
    />
  )
}

export default ProtectedMigrateRoute